import { componentTransformerRegistry as UiComponentTransformerRegistry } from '@commerce-webcomponents/ui';
import componentTransformerRegistry from '../../cms/registries/componentTransformerRegistry';
import CmsComponent from '../CmsComponent/CmsComponent';
import type { CmsComponentProps } from '../CmsComponent/types/propTypes';
import { CMSDataType } from '../../utils/common';
import { checkNonNullArrayOrNonEmptyObject } from '../../utils/utils';
import type { ModularBlockComponentProps } from './types/propTypes';

const ModularBlockComponent = ({
  data,
  sanitizeComponentsConfig: sanitizeComponentConfig,
  componentStylesConfig = {},
  ...componentRestProps
}: ModularBlockComponentProps) => {
  const doesComponentExist = (key: string, component: CMSDataType) =>
    key in component && checkNonNullArrayOrNonEmptyObject(component[key]);

  const modularBlockData: CmsComponentProps[] = data?.reduce(
    (
      acc: CmsComponentProps[],
      item: {
        [x: string]: CMSDataType;
      },
    ) => {
      const [componentKey] = Object.keys(item);

      // we're only adding the block if the component exists
      if (doesComponentExist(componentKey, item[componentKey])) {
        if (componentTransformerRegistry[componentKey] || UiComponentTransformerRegistry[componentKey]) {
          acc.push({
            componentKey,
            data: item[componentKey],
          });
        } else {
          acc.push({
            componentKey: 'default',
            data: item[componentKey],
          });
        }
      }
      return acc;
    },
    [],
  );
  return (
    <>
      {modularBlockData.map((item, index) => {
        const sanitizeConfig =
          sanitizeComponentConfig && sanitizeComponentConfig[item.componentKey]
            ? sanitizeComponentConfig[item.componentKey]
            : null;
        const customClassname = componentStylesConfig[item.componentKey] ?? '';
        return (
          <div
            className={customClassname}
            key={`${item.componentKey}#${index.toString()}`}
            data-testid={`test-${item.componentKey}`}
          >
            <CmsComponent
              componentKey={item.componentKey}
              data={item.data}
              {...sanitizeConfig}
              {...componentRestProps}
            />
          </div>
        );
      })}
    </>
  );
};

export default ModularBlockComponent;
